import { handleActions } from 'redux-actions';
import {
  getProfileById,
  getProfileByIdSuccess,
  getProfileByIdFailure,
  editUserProfile,
  editUserProfileSuccess,
  editUserProfileFailure,
  resetEditProfileStatus,
} from '../../actions/EditProfile';

import { combineReducers } from 'redux';
const initialState = {
  loading: false,
  data: null,
  edited: false,
  error: false,
  errorMessage: null,
};
const profile = handleActions(
  {
    [getProfileById]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [getProfileByIdSuccess]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [getProfileByIdFailure]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload.response.data.message,
      };
    },
    [editUserProfile]: (state, payload) => {
      return { ...state, loading: true };
    },
    [editUserProfileSuccess]: (state, payload) => {
      return { ...state, loading: false, edited: true };
    },
    [editUserProfileFailure]: (state, action) => {
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload.response.data.message,
      };
    },
    [resetEditProfileStatus]: (state, action) => {
      return initialState;
    },
  },
  initialState
);

export const edit = combineReducers({
  profile,
});
